/**
 * Doctor notes  screen
 *
 * @author Jinishakappil
 * @author Ashique
 * @description
 *
 *
 */
import ClinicalInformation from '../emr/components/clinical-information/clinical-information';

import React, { useEffect, useState, useRef, useContext } from 'react';

import VisitInfo from '../emr/components/visit-info/visit-info';

import PatientListResearch from '../imaging/components/patient-list/patient-list';

import './doctor-notes-screen.scss';

import { Form, Typography, Checkbox, Input, message, Skeleton, Col, Modal, Select, Row } from 'antd';

import { Location, ReferenceSelect, GlobalContext, useTranslation, ExtraInfoDetail, Button, Card } from 'soxo-bootstrap-core';

import { Questionaire } from './questionaire/questionaire';

import DoctorNotesLabResult from './lab-result/lab-result-doctor-notes';

import AiNotes from './generate-ai-notes/generate-ai-notes';

import { Clinicals, Samples, Doctors, Reports, GeneralLists, Appointments, scrreporttrans } from '../../models';

import { Trends } from './trends/trends';

import MedicalReports from '../common/components/medical-reports/medical-reports';

import { AimOutlined } from '@ant-design/icons';
import EventList from '../events/event-list';
import AuditLogList from '../audit-log/audit-log';

// import ExtraInfoDetail from '../extra-info-details/extra-info-details';
// import ExtraInfoDetail from '../extra-info-details/extra-info-details';

// Destructure the Typography component from Ant Design to get the Title element.
// Typography.Title is used for headings.
const { Title } = Typography;

// Destructure the Input component to get TextArea for multiline text input.
const { TextArea } = Input;

// Define layout properties for a Form.Item in vertical layout mode.
// This will be passed as props to each <Form.Item> to maintain consistency.
const formItemLayout = {
    layout: 'vertical', // Lays out labels above form controls instead of horizontally
};

/**
 *
 *
 * @param {*} param0
 * @returns
 */
export default function DoctorNotesScreening({
    mode,
    extraInfo, // To manage extra info component
    modeValue, // To mension mode for script execution
    title, // To mension title of extra info
    icon, // To mension icon
    disableCompare,
    enableQuestionnaireVerifier, // to QuestionnaireVerifier
    disablePagination,
    doctorNote,
    enableClincalEdit,
    enableDoctorSelection,
    templateCode, // to generate ai report
    generateAiReportModal, // manage ai report modal
    disableCheckBox,
    disableDoctorNotes,
    disableQuestionnaire,
    disableTrends,
    disablePublishReport,
    disableNotesEntry, // to manage mandate notes field
    // The readOnlyMode attribute is used to make the doctor notes screen readonly  ,
    readOnlyMode,
    test_code,
    generateAvatar,
    //Attribute to maintain extraInfo details
    extraInfoDetails = {},
    enableLegacyQuestionnaire,

    defaultScaleValue,

    defaultSizes,
    viewerType,
    callback,
    isTimeTracking,
    currentRoomPointer,
    // isCardView,
    ...props
}) {
    // Variable to save the guest details
    const [guest, setGuest] = useState({});

    const [physican, setPhysican] = useState(false);
    const [loading, setLoading] = useState(true);

    let [visible, setVisible] = useState(false);

    var urlParams = Location.search();

    // const [doctorCode, setDoctorCode] = useState(null);
    // const [doctorName, setDoctorName] = useState('');

    // const [doctorCode, setDoctorCode] = useState(null);
    const [isDoctorEditable, setIsDoctorEditable] = useState(true);
    const { user = {} } = useContext(GlobalContext);

    const [referenceId, setReferenceId] = useState(urlParams.opb_id ? urlParams.opb_id : props.opb_id);

    const [form] = Form.useForm();

    const { t, i18n } = useTranslation(); // To Translate to another language

    const [consultedStatus, setConsultedStatus] = useState(null);

    // let referenceId = urlParams.opb_id;

    useEffect(() => {
        loadGuestDetails();
        fetchAuthDetails();
    }, []);

    /**
     *
     */
    const loadGuestDetails = () => {
        if (urlParams.opb_id || props.opb_id) getDoctorNotes(referenceId);
    };
    /**
     * loading servicebaseclinical tran data
     */
    async function getDoctorNotes(referenceId) {
        setLoading(true);
        await Clinicals.getVitalInformation(referenceId).then((result) => {
            let data = result.result[0];

            let doctorCode;
            if (data) {
                doctorCode = data.srvbcd_doctorverifiedcode;
            }

            // set initial values for form
            if (data && data.srvbcd_doctorverified === 'Y') {
                setPhysican(true);
            } else {
                setPhysican(false);
            }
            // Determine the consulted status:
            // - Prefer the one from the fetched data
            // - Fallback to the user's own consulted status if not available
            // - Set to null if neither is available
            const consultedStatusValue = data?.srvbcd_consultedstatus || user?.consulted_status || null;
            setConsultedStatus(consultedStatusValue);
            // Set initial form values using either the fetched data or fallback values
            form.setFieldsValue({
                notes: data ? data.srvbcd_doctornotes : null,
                doctor_code: doctorCode ? doctorCode : user.doctor_code,
                srvbcd_consultedstatus: consultedStatusValue, // Set consulted status
            });

            setLoading(false);
        });
    }

    /**
     * generating AI avathar
     */

    function AvatarActionButton({ referenceId, opNo }) {
        const { t } = useTranslation(); // For translations
        const [btnLoading, setBtnLoading] = useState(false); // Manage loading state

        const generateAvatar = async () => {
            setBtnLoading(true); // Set loading to true
            try {
                const formBody = {
                    referenceId,
                    op_no: opNo,
                };

                // Call the API function
                const response = await scrreporttrans.getAvatar(formBody);

                if (response && response.success) {
                    message.success(response.message || t('Avatar generated successfully!'));
                } else {
                    message.error(response.message || t('Failed to generate avatar.'));
                }
            } catch (error) {
                console.log('error', error);
                message.error(t('An error occurred while generating the avatar.'));
            } finally {
                setBtnLoading(false); // Reset loading state
            }
        };

        return (
            <div className="avatar-action">
                {referenceId && opNo ? (
                    <Button type="primary" size="small" onClick={generateAvatar} loading={btnLoading}>
                        {t('Generate AI Avatar')}
                    </Button>
                ) : null}
            </div>
        );
    }

    // Function to fetch auth details and check doctor_code
    const fetchAuthDetails = async () => {
        try {
            const { doctor_code, name: doctor_name, consulted_status } = user || {};

            if (doctor_code) {
                form.setFieldsValue({
                    doctor_code: doctor_code || null,
                });
                setConsultedStatus(consulted_status || null);
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching profile:', error);
            setLoading(false);
        }
    };
    /**
     *
     * @param {*} e
     */
    function clinicalDataVerifictaion(e) {
        if (e.target.checked) {
            setPhysican(true);
        } else {
            setPhysican(false);
        }
    }

    /**
     * Create/ update record in servicebase clinical tran
     * @param {*} values
     */
    async function onFinish(values) {
        // formbody
        let formBody = {
            doctor_notes: values.notes,
            status: physican ? 'Y' : 'N',
            id: referenceId,
            doctor_visible: doctorNote,
            doctor_code: values.doctor_code,
            reference_number: urlParams.opno,
            consulted_status: values.srvbcd_consultedstatus ?? null, // consultation status
        };
        let result = await Samples.serviceEntry(formBody);

        if (result.success) {
            message.success('Successfully Updated');
            // Location.back();
        } else {
            message.error('failed');
        }
    }

    /**
     * Function to navigate to the patient view screen for follow-up entry.
     */
    function followUpEntry() {
        // Navigate to the patient-view-tech page with specific parameters

        Location.navigate({
            url: `patient-view-tech/${props.OPNo}?accessionno=${props.AccessionNo}&mode=OTR&opb_id=${props.opb_id}&item_ptr=${props.TestCode}`,
        });
    }

    return (
        <Card className="doctor-screening">
            <div className="doctor-note ">
                <div className="page-header">
                    <div className="right page-actions">
                        {/*Extra Info component start  */}
                        {extraInfoDetails.extraInfo && !readOnlyMode ? (
                            <ExtraInfoDetail
                                {...urlParams}
                                // record={urlParams}
                                modeValue={extraInfoDetails.modeValue}
                                title={extraInfoDetails.title}
                                icon={extraInfoDetails.icon}
                                tabPosition="top"
                            />
                        ) : null}

                        {/* <AiNotes
                            templateDetails={templateDetails}
                            referenceId={referenceId}
                            opNo={guest.opno}
                            templateCode={templateCode}
                            generateAiReportModal={generateAiReportModal}
                            setHtml={setHtml}
                        /> */}
                        {/*Extra Info component end  */}
                        {templateCode ? (
                            <div>
                                <div className="paga-actions">
                                    <Button
                                        type="primary"
                                        size={'small'}
                                        onClick={() => {
                                            setVisible(true);
                                        }}
                                    >
                                        {t('View AI Physician Note')}
                                        <AimOutlined />
                                    </Button>
                                </div>

                                <Modal
                                    destroyOnClose={true}
                                    visible={visible}
                                    footer={null}
                                    onCancel={() => {
                                        setVisible(false);
                                    }}
                                    width="80%"
                                    style={{ top: 20 }}
                                    maskClosable={false}
                                >
                                    <div>
                                        <MedicalReports
                                            billId={urlParams.opb_id}
                                            opNumber={urlParams.opno}
                                            /**manage ai report modal */
                                            generateAiReportModal={generateAiReportModal}
                                            reference_number={guest && guest.op_number ? guest.op_number : urlParams.opno}
                                            /**Template code from attribute */
                                            templateCode={templateCode}
                                            /**Guets data to be set for guest info */
                                            guestData={guest}
                                            isShowVisitInfo={false}
                                            props={props}
                                        />
                                    </div>
                                </Modal>
                            </div>
                        ) : null}

                        {/* Trends Component */}
                        {disablePublishReport || readOnlyMode ? null : <MedicantActionButton opNo={guest.opno} config={props.publish_report} />}
                        {/* Trends Component */}
                        {/* Avatar Action Button */}
                        {generateAvatar ? <AvatarActionButton referenceId={referenceId} opNo={guest.opno} /> : null}
                        {/* Trends Component */}
                        {disableTrends || readOnlyMode ? null : <Trends reference_id={referenceId} />}
                        {/* Trends Component */}
                        {/* Audit Log button */}
                        {props.auditLog?.mode ? <AuditLogList id={referenceId} props={props} record_id={referenceId} /> : null}
                    </div>
                    {/* <div className="right page-actions"> */}
                    {/* Questionnaire Component */}
                    {/* {disableQuestionnaire ? null : <Questionaire reference_id={referenceId} mode={mode} />} */}
                    {/* Questionnaire Component */}
                    {/* </div> */}
                </div>

                {/** Section one start here.it icnclude guestinformation and clinicalinformation  */}
                <div className="section-1">
                    {/* <div className='doctor-note-section'> */}
                    <div className="guest-information">
                        <VisitInfo
                            mode={'opreg'}
                            readOnlyMode={readOnlyMode}
                            disableCheckBox={disableCheckBox}
                            reference_number={urlParams.opno ? urlParams.opno : props.OPNo}
                            enableBillnumber={true}
                            startLoading={() => setLoading(true)}
                            onReceiveGuestDetails={(patient) => {
                                setGuest(patient);
                            }}
                            callback={async (values, bills) => {
                                // If the bills length is 1
                                // if (bills.length) {

                                //     // Set to the first guest
                                //     setGuest(bills[0]);
                                // }

                                setReferenceId(values);
                                // If the patient is changed using change pateint button, the url is changed according to the newly selcted customer
                                // For that opb_id, opb_bno and opb_opno are taken from the list of bills

                                let record = bills.filter((ele) => ele.opb_id === values)[0];

                                let redirectLink;

                                if (props.path) {
                                    redirectLink = props.path;
                                }

                                redirectLink = redirectLink.replace(':id', record.opb_id);

                                if (urlParams.opb_id !== record.opb_id)
                                    Location.navigate({
                                        url: `${redirectLink}?opb_id=${record.opb_id}&opb_no=${record.opb_bno}&opno=${record.opb_opno}`,
                                    });

                                // Get doctor notes of the selected bill_id
                                await getDoctorNotes(record.opb_id);
                            }}
                        ></VisitInfo>
                    </div>

                    <div className="clinical-information">
                        {!loading ? (
                            // Rendering the ClinicalInformation component with required details.
                            // It passes visit and reference information, controls whether editing is allowed,
                            // and manages read-only and time tracking features.
                            <ClinicalInformation
                                mode={mode}
                                visit_id={referenceId} // ID of the visit to fetch clinical data
                                enableModel={enableClincalEdit} // Whether clinical editing is enabled
                                refrence_number={urlParams.opno ? urlParams.opno : props.OPNo} // Reference number from URL or props
                                refrence_id={urlParams.opb_id ? urlParams.opb_id : props.opb_id} // Reference ID from URL or props
                                readOnlyMode={readOnlyMode} // If true, component is in read-only mode
                                isTimeTracking={isTimeTracking} // Enables time tracking if true
                                currentRoomPointer={currentRoomPointer} // Indicates the current clinical room/context
                            ></ClinicalInformation>
                        ) : null}
                    </div>

                    <div>
                        {isTimeTracking && !loading ? (
                            <EventList params={urlParams} isCardView={true} currentRoomPointer={currentRoomPointer}></EventList>
                        ) : null}
                    </div>
                    {/* </div> */}
                </div>
                {/** section one end */}

                {disableDoctorNotes ? null : (
                    <div className="section-2">
                        <div className="second-container">
                            <div className="page-title" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="page-header-left" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {disableCompare || readOnlyMode ? null : (
                                        <Button type="primary">
                                            {/* <FontAwesomeIcon icon={faShuffle} className="fa-icon fa-sharp" />&nbsp;&nbsp; */}
                                            {t('Compare')}
                                        </Button>
                                    )}
                                </div>
                            </div>
                            {!loading ? (
                                <div className="summary" style={{ display: 'flex', gap: '10px' }}>
                                    <div className="tech-entry-information">
                                        <PatientListResearch
                                            match={''}
                                            mode={'TECH'}
                                            defaultScaleValue={defaultScaleValue}
                                            defaultSizes={defaultSizes}
                                            viewerType={viewerType}
                                            disablePagination={disablePagination}
                                            doctorNote={doctorNote}
                                            reference_id={referenceId}
                                            readOnlyMode={readOnlyMode}
                                            test_code={test_code}
                                            {...props}
                                        ></PatientListResearch>
                                    </div>
                                    <div className="result-entry-details">
                                        <DoctorNotesLabResult {...props} mode={mode} bill_id={referenceId}></DoctorNotesLabResult>
                                    </div>
                                </div>
                            ) : null}
                            {/** physcian notes section start */}
                            {!loading ? (
                                <div className="card card-shadow">
                                    <Form {...formItemLayout} form={form} onFinish={onFinish}>
                                        <Row gutter={16}>
                                            <Col xs={24} md={24} xl={10}>
                                                {readOnlyMode ? null : (
                                                    <Form.Item
                                                        name={'doctor_code'}
                                                        label={t('Doctor')}
                                                        rules={[
                                                            {
                                                                required: enableDoctorSelection,
                                                                message: t('Please enter doctor'),
                                                            },
                                                        ]}
                                                        // initialValue={doctorCode} // Pre-fill the doctor_code if available
                                                    >
                                                        <ReferenceSelect
                                                            field="do_code"
                                                            config={{
                                                                queries: [
                                                                    {
                                                                        field: 'do_active',

                                                                        value: 'Y',
                                                                    },
                                                                ],
                                                            }}
                                                            label={t('do_name')}
                                                            mode="nura-base"
                                                            model={Doctors}
                                                            disabled={user.doctor_code ? !enableDoctorSelection : false} // Editable if doctor_code is absent or enableDoctorSelection is true
                                                            placeholder={user.doctor_code ? user.doctor_name : t('Select a doctor')} // Show doctor_name only if doctor_code is present
                                                        />
                                                    </Form.Item>
                                                )}
                                            </Col>
                                            <Col xs={24} md={24} xl={10}>
                                                <Form.Item
                                                    label={t('Consultation Status')}
                                                    name="srvbcd_consultedstatus"
                                                    rules={[{ required: false }]} // or your desired rules
                                                >
                                                    <ReferenceSelect
                                                        field="genl_code"
                                                        label="genl_desc"
                                                        allowClear={true}
                                                        config={{
                                                            queries: [
                                                                {
                                                                    field: 'genl_mode',
                                                                    value: 'NDCS',
                                                                },
                                                            ],
                                                        }}
                                                        mode="nura-base"
                                                        model={GeneralLists}
                                                        sortKey="genl_slno"
                                                        sortOrder="asec"
                                                        placeholder={t('Select Consultation Status')}
                                                        value={consultedStatus}
                                                        onChange={(val) => {
                                                            setConsultedStatus(val);
                                                            form.setFieldsValue({ srvbcd_consultedstatus: val });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item
                                            name="notes"
                                            label={t('Notes')}
                                            rules={
                                                disableNotesEntry
                                                    ? [{ max: 6000, message: t('Length cannot exceed 6000 characters!') }]
                                                    : [
                                                          { required: true, message: t('Please Enter Notes') },
                                                          { max: 6000, message: t('Length cannot exceed 6000 characters!') },
                                                      ]
                                            }
                                        >
                                            <TextArea readOnly={readOnlyMode ? readOnlyMode : false} rows={10}></TextArea>
                                        </Form.Item>
                                        {/* description and Questionnaire Component */}
                                        {disableQuestionnaire || readOnlyMode ? null : (
                                            // <div className='questionaire'>
                                            <Questionaire
                                                reference_id={referenceId}
                                                mode={mode}
                                                enableLegacyQuestionnaire={enableLegacyQuestionnaire}
                                                physican={physican}
                                                enableQuestionnaireVerifier={enableQuestionnaireVerifier}
                                                onVerify={() => {
                                                    setPhysican(true); // Automatically check "Clinical Data Verified"
                                                }}
                                            />
                                            // </div>
                                        )}

                                        <Form.Item name="" label="">
                                            <Checkbox
                                                disabled={(enableQuestionnaireVerifier && !physican) || readOnlyMode}
                                                checked={physican}
                                                onChange={clinicalDataVerifictaion}
                                            >
                                                {t('Clinical Data verified')}
                                            </Checkbox>
                                        </Form.Item>

                                        <Form.Item>
                                            {readOnlyMode ? (
                                                <>
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        <Button
                                                            type="primary"
                                                            htmlType="submit"
                                                            onClick={() => {
                                                                followUpEntry();
                                                            }}
                                                        >
                                                            Follow Up Entry
                                                        </Button>

                                                        <Button
                                                            // type="primary"
                                                            htmlType="submit"
                                                            onClick={() => {
                                                                // history.goBack();
                                                                callback();
                                                            }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                </>
                                            ) : (
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    disabled={enableQuestionnaireVerifier ? !physican : false}

                                                    // Enable submit only if "Clinical Data Verified" is checked
                                                >
                                                    {t('Submit')}
                                                </Button>
                                            )}
                                        </Form.Item>
                                    </Form>
                                </div>
                            ) : null}

                            {/** physcian note section end */}
                        </div>
                    </div>
                )}
                {/**section 2 starts here . it include radiology information and lab details */}
            </div>
        </Card>
    );
}

/**
 *
 */
function MedicantActionButton({ opNo, config }) {
    //
    const { user = {} } = useContext(GlobalContext);

    const { t, i18n } = useTranslation(); // To Translate to another language
    const [btnloading, setBtnLoading] = useState(false);

    /**
     *
     */
    const callButton = async () => {
        setBtnLoading(true);
        const result = await Reports.callMedicantExe({ config, user, opNo });
        setBtnLoading(false);
    };

    return (
        <>
            <div className="paga-actions">
                {opNo ? (
                    <>
                        <Button
                            type="primary"
                            size={'small'}
                            onClick={() => {
                                callButton();
                            }}
                            loading={btnloading}
                        >
                            {t('Create Final Report')}
                        </Button>
                    </>
                ) : null}
            </div>
        </>
    );
}
